import React, { useEffect } from 'react';
import { useProStatusListener } from '../hooks/useProStatusListener';
import { useNavigate } from 'react-router-dom';
interface ProStatusListenerProps {
  onProActivated?: () => void;
  redirectToDashboard?: boolean;
  showCelebration?: boolean;
  enableLogging?: boolean;
  showConnectionStatus?: boolean;
}
export function ProStatusListener({
  onProActivated,
  redirectToDashboard = false,
  showCelebration = true,
  enableLogging = false,
  showConnectionStatus = false
}: ProStatusListenerProps) {
  const {
    justBecamePro,
    resetProCelebration,
    connectionStatus,
    error
  } = useProStatusListener({
    onProActivated: () => {
      if (onProActivated) {
        onProActivated();
      }
      if (redirectToDashboard) {
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 3000);
      }
    },
    onError: err => {
      console.error('[ProStatusListener] Connection error:', err.message);
    },
    enableLogging
  });
  useEffect(() => {
    if (justBecamePro && showCelebration) {
      const timer = setTimeout(() => {
        resetProCelebration();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [justBecamePro, showCelebration, resetProCelebration]);
  // Show connection status for debugging (optional)
  if (showConnectionStatus && connectionStatus === 'error' && error) {
    return <div className="fixed bottom-4 right-4 bg-red-50 border border-red-200 rounded-lg p-4 max-w-sm shadow-lg z-50" data-id="element-1673" data-mp="1d9vmk3iqs25m">
        <div className="flex items-start gap-3" data-id="element-1674" data-mp="18bakdyjxj8ej">
          <svg className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1675" data-mp="188g1wckh7xnr">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" data-id="element-1676" data-mp="z8sw7ekps5ow" />
          </svg>
          <div className="flex-1" data-id="element-1677" data-mp="3qg1y4omrwxya">
            <p className="text-sm font-medium text-red-800" data-id="element-1678" data-mp="3qgbmy8w30z2e">
              Realtime Connection Error
            </p>
            <p className="text-xs text-red-600 mt-1" data-id="element-1679" data-mp="3bhztsc7x48fz">{error.message}</p>
          </div>
        </div>
      </div>;
  }
  if (!justBecamePro || !showCelebration) {
    return null;
  }
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm" data-id="element-1680" data-mp="32pph8o9jvqvk">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 text-center animate-scale-in" data-id="element-1681" data-mp="37iqyv41564iu">
        <div className="mb-4" data-id="element-1682" data-mp="2su4n1caq3uwd">
          <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full mx-auto flex items-center justify-center animate-bounce" data-id="element-1683" data-mp="2xre8yhywlofg">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1684" data-mp="2js542eg5egqs">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-1685" data-mp="2544szqm7lriq" />
            </svg>
          </div>
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1686" data-mp="2e75xjmvffaka">
          Welcome to Pro! 🎉
        </h2>

        <p className="text-gray-600 mb-6" data-id="element-1687" data-mp="2956s87g4m3kp">
          Your Pro subscription is now active. Enjoy unlimited access to all
          premium features!
        </p>

        <div className="flex gap-3 justify-center" data-id="element-1688" data-mp="2j5h7rypmvn31">
          <button onClick={() => {
          resetProCelebration();
          window.location.href = '/dashboard';
        }} className="px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-pink-700 transition-all" data-id="element-1689" data-mp="2j2l7w4u86oby">
            Go to Dashboard
          </button>

          <button onClick={resetProCelebration} className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-all" data-id="element-1690" data-mp="31wqj8diyslx9">
            Continue
          </button>
        </div>
      </div>
    </div>;
}